import { defineMessages } from 'react-intl'

export default defineMessages({
  maxWordsPrice: {
    id: 'containers.Price.maxWordsPrice',
    defaultMessage: '{words} words from {price}',
  },
  absolutePrice: {
    id: 'containers.Price.absolutePrice',
    defaultMessage: 'from {price}',
  },
  onRequest: {
    id: 'containers.Price.onRequest',
    defaultMessage: 'Rates on request',
  },
  actionRequired: {
    id: 'containers.Price.actionRequired',
    defaultMessage: 'Select category to see price',
  },
  perVoiceTalent: {
    id: 'containers.Price.perVoiceTalent',
    defaultMessage: 'per voice talent',
  },
})
